export const state = () => ({
  host: process.env.apiUrl,
  content: {
    loaded: false,
    item: [],
  },
  copyright: {
    loaded: false,
    item: [],
  },
  privacy: {
    loaded: false,
    item: [],
  },
  counters: {
    loaded: false,
    item: [],
  },
});

export const mutations = {
  setMainContent(state, payLoad) {
    state.content.item =  payLoad
    state.content.loaded = true
  },
  setCopyright(state, payLoad) {
    state.copyright.item =  payLoad
    state.copyright.loaded = true
  },
  setPrivacy(state, payLoad) {
    state.privacy.item =  payLoad
    state.privacy.loaded = true
  },
  setCounters(state, payLoad) {
    state.counters.item =  payLoad
    state.counters.loaded = true
  },
};

export const actions = {

  async mainContent({commit,dispatch,state}) {
    try {
      const response = await this.$axios.$get(`${state.host}/methods/site/main_texts/`)
      commit('setMainContent', response)
      return  response
    } catch (e) {
      dispatch('showRequestError', error, { root: true });
      throw e
    }
  },
  async fetchCopyright({commit,dispatch,state}) {
    try {
      const response = await this.$axios.$get(`${state.host}/methods/site/copyright/`)
      commit('setCopyright', response)
      return  response
    } catch (e) {
      dispatch('showRequestError', error, { root: true });
      throw e
    }
  },
  async fetchPrivacy({commit,dispatch,state}) {
    try {
      const response = await this.$axios.$get(`${state.host}/methods/site/privacy/`)
      commit('setPrivacy', response)
      return  response
    } catch (e) {
      dispatch('showRequestError', error, { root: true });
      throw e
    }
  },
  async fetchCounters({commit,dispatch,state}) {
    try {
      const response = await this.$axios.$get(`${state.host}/methods/site/counters/`);
      commit('setCounters', response)
      return  response
    } catch (e) {
      dispatch('showRequestError', error, { root: true });
      throw e
    }
  },
};

export const getters = {
  mainContent (state) {
    return state.content
  },
  copyright (state) {
    return state.copyright
  },
  privacy (state) {
    return state.privacy
  },
  counters (state) {
    return state.counters
  },
}



// WEBPACK FOOTER //
// ./store/main.js